import PropTypes from "prop-types";

import { LineChart } from "components/AtomsV2";

/* Shared revamp chart card for the energy-management module charts: rec card
   with a title + optional subtitle, an optional legend, an optional toolbar
   slot (e.g. a resource selector) and the AtomsV2 LineChart below. */
export default function EmsChartCard({
  title,
  sub,
  legend,
  toolbar,
  series,
  labels,
  timestamps,
  height,
  unit,
  type,
  xTitle,
  yTitle,
  yTitleRight,
  yMin,
  yMax,
  yMinRight,
  yMaxRight,
  stacked,
}) {
  return (
    <div className="rec-card rec-card-pad rec-ems-chart">
      <div className="flex items-start justify-between gap-3 flex-wrap mb-2">
        <div className="min-w-0">
          <h3 className="rec-section-title !mb-0">{title}</h3>
          {sub && <div className="text-[12.5px] text-ink-3 mt-1">{sub}</div>}
        </div>
        <div className="flex items-center gap-[14px] flex-wrap">
          {legend && legend.length > 0 && (
            <div className="flex items-center gap-[14px] flex-wrap text-[12px] text-ink-2">
              {legend.map((l) => (
                <span key={l.label} className="inline-flex items-center gap-[6px]">
                  <i
                    className="inline-block w-[9px] h-[9px] rounded-[3px]"
                    style={{ background: l.color }}
                  />
                  {l.label}
                </span>
              ))}
            </div>
          )}
          {toolbar}
        </div>
      </div>
      <LineChart
        series={series}
        labels={labels}
        timestamps={timestamps}
        height={height}
        unit={unit}
        type={type}
        xTitle={xTitle}
        yTitle={yTitle}
        yTitleRight={yTitleRight}
        yMin={yMin}
        yMax={yMax}
        yMinRight={yMinRight}
        yMaxRight={yMaxRight}
        stacked={stacked}
      />
    </div>
  );
}

EmsChartCard.propTypes = {
  title: PropTypes.node.isRequired,
  sub: PropTypes.node,
  legend: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.node, color: PropTypes.string })),
  toolbar: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  series: PropTypes.array.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string),
  timestamps: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  height: PropTypes.number,
  unit: PropTypes.string,
  type: PropTypes.oneOf(["area", "line", "bar"]),
  xTitle: PropTypes.string,
  yTitle: PropTypes.string,
  yTitleRight: PropTypes.string,
  yMin: PropTypes.number,
  yMax: PropTypes.number,
  yMinRight: PropTypes.number,
  yMaxRight: PropTypes.number,
  stacked: PropTypes.bool,
};

EmsChartCard.defaultProps = {
  sub: null,
  legend: null,
  toolbar: null,
  labels: [],
  timestamps: undefined,
  height: 380,
  unit: "",
  type: "area",
  xTitle: undefined,
  yTitle: undefined,
  yTitleRight: undefined,
  yMin: undefined,
  yMax: undefined,
  yMinRight: undefined,
  yMaxRight: undefined,
  stacked: false,
};
